define('models/OrderModel',['underscore','ObjectModel','LocalStorage', 'app','models/CartProductCollection', 'ApiRequest', 'formatPrice','moment','momentFormats','MysqlDatetimeFormat'],

    function (_,ObjectModel,LocalStorage, app, CartProductCollection, ApiRequest, formatPrice, moment,momentFormats,MysqlDatetimeFormat) {
    //
    // Model Order
    //

    var ORDER_TRANSLATION_CONTEXT = 'Order';

    var OrderModelPrototype = {

        name:'OrderModel',
        route:'apiOrderModel',
        idAttribute:'id_order',

        defaults:{
            has_invoice:true,
        },

        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
        },
        testOrderExist:function(id_cart)
        {
             ApiRequest('OrderValidate','', {id_cart:id_cart})
                .done(function (data, status)
                {
                    app.trigger('newOrderCreate');
                })
                .fail(function (data, status)
                {

                });
        },
        //
        isVAE:function(){
            return parseInt(this.get('vae'))==1;
        },
        formatDeliveryMode:function(){
            return this.isVAE() ? t('Click and Collect',ORDER_TRANSLATION_CONTEXT) : t('Livraison',ORDER_TRANSLATION_CONTEXT);
        },
        getName:function(){
            return this.get('name');
        },
        isWeb:function(){
            return this.get('canal') === 'WEB';
        },
        isDesk:function(){
            // commande effectuée en boutique
            return this.get('canal') === 'DESK';
        },
        isDesktop:function(){
            var model = this, isWeb = model.isWeb(), isDesktop;
            // origin
            // 0, desktop
            // 1, app ios
            // 2, app android
            // 3, app ipad
            // 4, web mobile
            // 11,
            switch(model.get('origin')){
                case '0':
                    isDesktop = isWeb && true;
                    break;
                default:
                    isDesktop = false;
            }
            return isDesktop;
        },

        getTypeIcon:function(){
            var model = this, icon;
            if(model.isDesk()){
                icon = 'clickandco';
            }else if(model.isDesktop()){
                icon = 'screen';
            }else{
                icon = 'phone';
            }
            return icon;
        },

        getYear:function(){
            return this.getDate().getFullYear();
        },

        getType:function(){
            var model = this, label;
            if(model.isDesk()){
                return 1
            }else if(model.isDesktop()){
                return 2
            }else{
                return 3
            }
            return 0
        },

        getFullTypeLabel:function(){
            var model = this,
                typeLabel = model.getTypeLabel(),
                deliveryLabel = model.getDeliveryLabel();
            return typeLabel+' '+deliveryLabel.toLowerCase();
        },

        getTypeLabel:function(){
            var model = this, label;
            if(model.isDesk()){
                label = 'Commande en boutique';
            }else if(model.isDesktop()){
                label = "Commande desktop";
            }else{
                label = "Commande mobile";
            }
            return app.t(label,"Account");
        },

        getDeliveryLabel:function(){
            var model = this, label;
            if(model.isVAE()){
                label = "À emporter";
            }else{
                label = "En livraison";
            }
            return app.t(label,"Account");
        },

        getProgressSteps:function(){
            var steps = [],
                model = this,
                isVAE = model.isVAE(),
                isVAD = !isVAE,
                stepCount = isVAE ? 3 : 4,
                percent = model.getPercent(),
                isPrevHighLight = false,
                currentStep = Math.round(stepCount * percent/100)
            ;
            function AddStep(text,VAD,VAE){
                if((isVAE && !!VAE) || (isVAD && !!VAD)){
                    var n = steps.length,
                        finished = (percent === 100 && (n+1) === stepCount),
                        complete = n<currentStep || finished,
                        progress = n===currentStep && !complete,
                        highlight = progress || finished,
                        translatedText = app.t(text,'Order'),
                        label = highlight ? model.getStatusName() || translatedText : translatedText,
                        step = {
                            label:label,
                            finished:finished,
                            progress:progress,
                            complete:complete,
                            highlight:highlight,
                            isNext:isPrevHighLight,
                        }
                    ;
                    isPrevHighLight = highlight;
                    steps.push(step)
                }
            }
            AddStep('Validée',1,1);
            AddStep('En cours de préparation',1,1);
            AddStep('Expédiée',1,0);
            AddStep('Livrée',1,0);
            AddStep('Commande Retirée',0,1);
            return _(steps);
        },

        getLocationStatus:function(){
            var model = this,
                location = '',
                locationStatus = '',
                isVAE = model.isVAE();
            if(model.isCanceled()){
                locationStatus = 'Votre commande a été annulée';
            }else if(model.isComplete()){
                locationStatus = 'Bonne dégustation et à bientôt chez Sushi Shop !';
            }else if(isVAE){
                location = model.formatStore();
                locationStatus = 'La commande sera disponible à %s'
            }else{
                location = model.formatAddress();
                locationStatus = 'Livraison prévue à %s';
            }
            return app.t(locationStatus,'Order',location);
        },

        getTimingStatus:function(){
            var model = this,
                timingStatus = '',
                is100Percent = model.is100Percent(),
                isNow = model.isNow();
            if(isNow && is100Percent){
                timingStatus = model.formatDate('LT','date_change_status');
            }else if(isNow){
                timingStatus =
                    model.formatDate('LT','delivery_date_desired_min')
                    +' - '+
                    model.formatDate('LT','delivery_date_desired_max')
            }else{
                var isSameDay = model.getDateMoment('delivery_date_desired').isSame(new Date(),'d');
                timingStatus = model.formatDate(isSameDay ? 'LT':'LLL','delivery_date_desired')
            }
            return timingStatus;
        },

        getTrackingStatus:function(){
            var label, isVAE = this.isVAE(), isDiffer = this.isDiffer();
            if(isVAE){
                if(isDiffer){
                    label = 'La commande sera disponible le'
                }else{
                    label = 'La commande sera disponible à'
                }
            }else{
                if(isDiffer){
                    label = 'Livraison prévue le'
                }else{
                    label = 'Livraison prévue à'
                }
            }
            return app.t(label,'Order');
        },

        formatQuantity:function(offset){
            offset = offset || 0;
            var model = this,
                quantity = offset + model.get('products_quantity'),
                plural = Math.abs(quantity) !== 1,
                res = '';
            if(quantity !== 0){
                if(offset>0){
                    res+='-'
                }else if(offset<0){
                    res+='+'
                }
                res+=quantity+' '+app.t('produit'+(plural?'s':''),'UI')
            }else{
                res = ' ';
            }
            return res;
        },

        formatName:function(){
            var name = this.getName();
            switch(name){
                case undefined : case '' :
                    return t('Commande du %s',ORDER_TRANSLATION_CONTEXT,moment(this.getDate('date_add')).format('LLLL'));
                    break;
                default :
                    if(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(name)){
                        return t('Commande du %s',ORDER_TRANSLATION_CONTEXT,this.formatDate('LL'));
                    }
                    return name;
            }
        },
        getDate:function(type){
          type = !type ? 'date_add' : type;
          var date = this.get(type)||'';
          try{
              return MysqlDatetimeFormat(date);
          }catch(err){
          }
        },
        getDateMoment:function(type){
             return moment(this.getDate(type));
        },
        formatDate:function(format,type){
            var m = this.getDateMoment(type);
            return m.isValid() ? m.format(format) : '-';
        },
        formatDateCalendar:function(type){
            var m = this.getDateMoment(type);
            return m.isValid() ? m.calendar(new Date(), momentFormats.getFormats()) : '-';
        },
        formatDateShortCalendar:function(type) {
            var m = this.getDateMoment(type);
            return m.isValid() ? m.format('ddd DD MMMM'): '-'
        },
        getOrderDate:function () {
          //
          // TODO incompatibilité Safari, lié au format de date Mysql
          var date = this.get('date_add');
            if (date)
            {
                function pad(s) { return (s < 10) ? '0' + s : s; }
                var d = new Date(date);
                var day = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('-');
                var hour = [pad(d.getHours()), pad(d.getMinutes()+1)].join(':');
                // TODO traduction
                return day + ' à '  + hour;
            }else
            {
                return '';
            }
        },
        isNow:function(){
            return this.get('now') === 1;
        },
        isDiffer:function(){
            return this.get('now') === -1;
        },
        getPercent:function(){
            var percent = parseFloat(this.get('pourcent'));
            return percent>=0 ? percent : 0;
        },
        is100Percent:function(){
            return this.getPercent() === 100;
        },
        isWebOrder:function()
        {
            var is_web = this.get('is_web');
            return is_web;
        },
        isCanceled:function(){
            var _ORDER_STATE_CANCELED_DELIVERY_ = app.c('_ORDER_STATE_CANCELED_DELIVERY_','24'),
                _ORDER_STATE_CANCELED_PICKUP_ = app.c('_ORDER_STATE_CANCELED_PICKUP_','28');
            return _([_ORDER_STATE_CANCELED_DELIVERY_,_ORDER_STATE_CANCELED_PICKUP_]).contains(this.get('id_order_state'))
        },
        isComplete:function(){
            return this.get('completed');
        },
        getStatusName:function(){
            var status_name = this.get('status_name');
            return status_name ;
        },
        getOrderState:function(){
            var state = this.get('id_order_state');
            return state || 0;
        },
        getDeliveryAddress:function(){
            return app.getAddress(this.get('id_address_delivery'));
        },
        getStore:function(){
            return app.getStore(this.get('id_store'));
        },
        getMoment:function(type){
            if(!type) type = 'delivery_date_desired';
            return moment(this.get(type),'YYYY-MM-DD HH:mm:ss');
        },
        isLunchService:function(){
            // est-ce que la commande est "du service du midi"
            //var _LUNCH_DINER_SERVICE_THRESHOLD_TIME_ = parseInt(app.c('_LUNCH_DINER_SERVICE_THRESHOLD_TIME_',16));
            return this.get('service') == '0';//this.getMoment().hours() < _LUNCH_DINER_SERVICE_THRESHOLD_TIME_;
        },
        isNowService:function(){
            // est-ce que la commande est du même service qu'en ce moment
            return app.isNowLunch() ^ this.isLunchService() == 0;
        },
        formatAddress:function(){
            var address = this.getDeliveryAddress();
            return address ? address.get('description') : '';
        },
        formatExtraPrice:function(price)
        {
            return formatPrice(price);
        },
        formatStore:function(){
            var store = this.getStore();
            if (_.isUndefined(store)) {
                return '';
            }
            return store.getName();
        },
        // TODO vérifier l'usage de cette fonction (peut-être utiliser amountReduce)
        getCagnotte:function () {
            var cagnotte = parseInt(this.get('cagnotte'));
            if(cagnotte>0){
                return formatPrice(cagnotte);
            }
             return formatPrice(0);
        },
        getPaymentMethod:function(){
            return app.getPaymentMethod(this.get('id_payment_method'));
        },
        getPaymentMethodName:function(){
            var paymentMethod = this.getPaymentMethod();
            return paymentMethod ? paymentMethod.getName() : '';
        },
        getAmountReduce:function(){
          // utilisation de la cagnotte
          return parseFloat(this.get('amountReduce') || 0);
        },
        formatPaymentMethod:function(){
            var paymentMethod = this.getPaymentMethod();
            return paymentMethod ? paymentMethod.getName() : '';
        },
        formatTotalPaid:function(real){
            var total_paid = this.getTotalPaid(real,false);
            if(total_paid>0){
                return formatPrice(total_paid);
            }
            return '-';
        },
        formatTotalPaidReal:function(){
            return this.formatTotalPaid(true);
        },
        getTotalPaid:function(real,excludeExtraPrice){
            var totalPaid = parseFloat(this.get('total_paid'+(real?'_real':'')));
            if(excludeExtraPrice){
                totalPaid -= this.getExtraPriceValue();
            }
            return totalPaid;
        },
        getExtraPriceValue:function(){
            var extraPriceValue = 0,
                extraPrice = this.get('extraPrice');
            _(extraPrice).each(function(e){
                if(!e.free){
                    extraPriceValue += parseFloat(e.price_ttc);
                }
            });
            return extraPriceValue;
        },
        formatLoyalty:function(){
            return '-';
        },
        formatShop:function(){
            var store = app.getStore(this.get('id_store'));
            return store ? store.getName() : '';
        },
        formatReorderNp1Product:function(){
            var nbr_product = this.get('nbr_product'), res = '+ '+(nbr_product-1)+' ';
            if(nbr_product > 2){
                res += app.t('produits', 'UI')
            }else if(nbr_product > 1){
                res += app.t('produit', 'UI')
            }else{
                res = ' ' // &nbsp;
            }
            return res;
        },
        // pour CartProductModel
        hasStore:function(){return true}, // cart && order utilise les mêmes fonctions
        getMaxPriceProduct: function() {
            var product, maxPriceProduct = this.get('max_product_price')
            if (!maxPriceProduct) {
                return false
            }
            // on essaie d'utiliser les données de la commande
            product = this.getProducts().findWhere({id_product:maxPriceProduct});
            if(!product){
                // à défaut, on essaie avec les données API publique
                product = app.getProduct(maxPriceProduct);
            }
            return product;
        },
        getProducts:function()
        {
            var order = this,
                products = order.products;
            if(!products){
                products = new CartProductCollection();
                products.attachCart(order,'detail');
            }
            return products;
        },
        hasInvoice: function () {
            return !!this.get('has_invoice') && !!this.get('hash');
        },
        getInvoiceUrl:function(){
            return this.get('invoice_url');
        },
        displayInvoice: function(){
            var store = this.getStore();

            return !!parseInt(app.c('_ENABLE_INVOICE_',0)) &&  !!store.get('enable_invoice');
        }
    };

    var OrderModel = ObjectModel.extend(LocalStorage).extend(OrderModelPrototype);

    return OrderModel;
});
